// INTERFACES
import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnInit,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  trackByValue,
  IActivityLog,
  IPagination,
  PaginationConfig,
  SnackBarConfig,
} from '../../modules';
import { ActivityLogApiService } from '../../modules/activity-log/services/activity-log-api.service';
import { UiEmptyPageStandaloneComponent } from '../../modules/ui/components/ui-empty-page/ui-empty-page.component';
import { UiModule } from '../../modules/ui/ui.module';

@Component({
  selector: 'lum-activity-log',
  templateUrl: './activity-log.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    UiEmptyPageStandaloneComponent,
    UiModule,
  ],
  styleUrls: ['./activity-log.component.scss'],
})
export class ActivityLogComponent implements OnInit, OnDestroy {
  @Input()
  subjectId :string;

  @Input()
  subjectType :string;

  activityLogs :IActivityLog[];

  trackByValue = trackByValue;

  loading :boolean = false;

  paginationConfig = PaginationConfig;
  pagination :IPagination = {
    current_page: 1,
    from: null,
    last_page: 1,
    path: '',
    per_page: 1,
    to: null,
    total: 0,
  };

  queryParams :{ [param :string] :string | string[] };

  relations :string = ['causer'].join('|');

  private onDestroy$ = new Subject();

  constructor(
    private activityLogApiService :ActivityLogApiService,
    private cd :ChangeDetectorRef,
    private snackBar :MatSnackBar,
  ) {}

  ngOnInit() :void {
    this.getActivityLogs();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onShowMore() :void {
    if (this.pagination.current_page < this.pagination.last_page) {
      this.queryParams = {
        ...this.queryParams,
        page: (this.pagination.current_page + 1).toString(),
      };
      this.getActivityLogs(true);
    }
  }

  private getActivityLogs(append :boolean = false) :void {
    this.loading = true;
    this.activityLogApiService
      .get({
        ...this.queryParams,
        subjectType: this.subjectType,
        subjectId: this.subjectId,
        relations: this.relations,
      })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (response) => {
          this.loading = false;
          this.activityLogs = append
            ? [...this.activityLogs, ...response?.data]
            : response?.data;
          this.pagination = response?.meta;
          this.cd.detectChanges();
        },
        error: (response) => {
          this.loading = false;
          this.snackBar.open(response.error, 'Fail', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
          this.cd.detectChanges();
        },
      });
  }
}
